'use client';
import { ReadonlyURLSearchParams, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import {
	loadFromSessionStorage,
	saveToSessionStorage,
	ssKeys,
} from '~features/storage';
import { usePathname, useRouter } from '~i18n/navigation';
import { getQueryObjectFromSearchParams } from '~shared/utils/getQueryObjectFromSearchParams';
import { updateQueryParamsWithPathname } from '~shared/utils/searchParams';

import type { TGridFiltersValues } from '../model/types';
import { parseFilters } from '../utils/parseFilters';

const emptySearchParams = new ReadonlyURLSearchParams();

export function useLoadSavedFilters(skip: boolean = false) {
	const router = useRouter();
	const pathname = usePathname();
	const searchParams = useSearchParams();

	useEffect(() => {
		if (skip) {
			return;
		}

		const hasSearchParams = searchParams.toString() !== '';
		if (hasSearchParams) {
			const filtersFromSearchParams = parseFilters(
				getQueryObjectFromSearchParams(searchParams)
			) as TGridFiltersValues;

			const hasFilters = Object.keys(filtersFromSearchParams).length > 0;

			if (hasFilters) {
				saveToSessionStorage(ssKeys.GRID_FILTERS, filtersFromSearchParams);
			}
		} else {
			const filters = loadFromSessionStorage(ssKeys.GRID_FILTERS, {});

			if (Object.keys(filters).length > 0) {
				const href = updateQueryParamsWithPathname(
					filters,
					pathname,
					emptySearchParams
				);

				setTimeout(() => router.replace(href), 0);
			}
		}
	}, [router, pathname, skip, searchParams]);
}
